module.exports = __webpack_public_path__ + "img/case3.0714fc12.png";